import { Card, Text, BlockStack, InlineStack, Icon, Box } from '@shopify/polaris';
import type { IconSource } from '@shopify/polaris';

interface StatsCardProps {
  title: string;
  value: number | string;
  icon: IconSource;
  helpText?: string;
  trend?: 'positive' | 'negative' | 'neutral';
  trendValue?: string;
}

export default function StatsCard({
  title,
  value,
  icon,
  helpText,
  trend,
  trendValue,
}: StatsCardProps) {
  const trendColor =
    trend === 'positive' ? 'success' : trend === 'negative' ? 'critical' : 'subdued';

  return (
    <Card>
      <BlockStack gap="200">
        <InlineStack align="space-between" blockAlign="center">
          <Text as="span" variant="bodySm" tone="subdued">
            {title}
          </Text>
          <Box>
            <Icon source={icon} tone="subdued" />
          </Box>
        </InlineStack>
        <Text as="span" variant="heading2xl">
          {value}
        </Text>
        {(helpText || trendValue) && (
          <InlineStack gap="200">
            {trendValue && (
              <Text as="span" variant="bodySm" tone={trendColor}>
                {trend === 'positive' && '↑'}
                {trend === 'negative' && '↓'}
                {trendValue}
              </Text>
            )}
            {helpText && (
              <Text as="span" variant="bodySm" tone="subdued">
                {helpText}
              </Text>
            )}
          </InlineStack>
        )}
      </BlockStack>
    </Card>
  );
}
